import Vue from 'vue'

// initial state
const state = {
    points: 0,
    code:null,
    rewards:[]
}

const getters = {
    points: function (state) {
        return state.points;
    },
    rewards: function (state) {
        return state.rewards;
    },
    code: function (state) {
        return state.code;
    }
}

const mutations = {
    setPoints: function (state, points) {
        state.points = points
    },
    setRewards: function (state, rewards) {
        state.rewards = rewards
    },
    setCode: function (state, code) {
        state.code = code
    }
}

const actions= {
    getLoyaltyDataByUniqueCode: function (context, code){
        return new Promise((resolve, reject) => {
            Vue.http.get(wwfconfigs.CLOUDFUNCTION+'/'+ 'getLoyaltyDataByUniqueCode', {params:  {code: code}}).then(response => {
                console.log("getLoyaltyDataByUniqueCode", response)
                context.commit("setPoints",response.body.points);
                context.commit("setRewards",response.body.rewards);
                context.commit("setCode",code);
                resolve()
            }, error => {
                console.error("getLoyaltyDataByUniqueCode", error)
                reject(error)
            });
    })
    },
    saveReward: function (context, data) {
        return new Promise((resolve, reject) => {
            Vue.http.post(wwfconfigs.CLOUDFUNCTION+'/'+ 'saveLoyaltyDataByUniqueCode', {code: context.state.code, email: data.email, firstname: data.firstname, lastname: data.lastname, phone: data.phone, rewardid: data.rewardid, address: data.address}).then(response => {
                console.log("saveReward", response)
                resolve()
            }, error => {
                console.error("saveReward", error)
                reject(error)
            });
        })
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/loyalty.js